import { render, staticRenderFns } from "./ImageGalleryWidget.vue?vue&type=template&id=27d7516f&scoped=true"
import script from "./ImageGalleryWidget.vue?vue&type=script&lang=js"
export * from "./ImageGalleryWidget.vue?vue&type=script&lang=js"
import style0 from "./ImageGalleryWidget.vue?vue&type=style&index=0&id=27d7516f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7516f",
  null
  
)

export default component.exports